import { FILE_UPLOAD_CHUNK_SIZE } from "../pages/Products/EditItem/Constants";
import api from "../services/ApiService";

// Function to clone FormData manually by copying key-value pairs
const cloneFormData = (sourceFormData) => {
    const newFormData = new FormData();
    for (const [key, value] of sourceFormData.entries()) {
        newFormData.append(key, value);
    }
    return newFormData;
};

type uploadChunkArgs = {
    fileAttachment: {
        file: File,
        attachType?: number,
        progressBarId?: string
    };
    baseFormData: any;
    chunkIndex: number;
    endpoint: string;
    onUploadProgress?: (progress: number) => void;
    finalSuccessCB?: (msg: string) => void;
    failureCB?: () => void;
}

// Recursive function to upload file in chunks using .then
export const uploadFileInChunks = async ({ fileAttachment, baseFormData, chunkIndex = 0, endpoint, onUploadProgress = undefined, finalSuccessCB, failureCB }: uploadChunkArgs) => {
    
    const { file } = fileAttachment;
    
    if (!file) return Promise.resolve();

    const totalChunks = Math.ceil(file.size / FILE_UPLOAD_CHUNK_SIZE);

    // Prepare the chunk to upload
    const start = chunkIndex * FILE_UPLOAD_CHUNK_SIZE;
    const chunk = file.slice(start, start + FILE_UPLOAD_CHUNK_SIZE);
    const chunkNumber = chunkIndex + 1;

    // Clone the base FormData manually
    const formData = cloneFormData(baseFormData);
    formData.append("file", chunk);
    formData.append("chunkNumber", String(chunkNumber));
    formData.append("totalChunks", String(totalChunks));
    
    if (formData.get("fileName")) {
        formData.delete("fileName");
    }
    
    formData.append("fileName", file?.name);

    // Upload the current chunk and recursively call for the next chunk
    return api
        .post(endpoint, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress: onUploadProgress ? () => {
                const progress = Math.round((chunkNumber / totalChunks) * 100);
                onUploadProgress(progress);
            } : undefined,
        }).then((data: any) => {
            // Check if all chunks are uploaded
            if (chunkNumber === totalChunks) {
                if (finalSuccessCB) {
                    finalSuccessCB(data?.message);
                };
                return Promise.resolve(data);
            }
            else {
                return uploadFileInChunks({ fileAttachment, baseFormData, chunkIndex: chunkIndex + 1, endpoint, onUploadProgress, finalSuccessCB, failureCB });
            }
        }).catch((error) => {
            if (failureCB) {
                failureCB();
            }
            console.error(`Error uploading chunk ${chunkNumber}:`, error);
            return Promise.reject(error);
        });
};